import script from "./softwareInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./softwareInfo.vue?vue&type=script&setup=true&lang=js"

import "./softwareInfo.vue?vue&type=style&index=0&id=2edc6424&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edc6424"]])

export default __exports__